
import { EcosystemFeatures } from "@/components/home/EcosystemFeatures";

export const MainCarousel = () => {
  return (
    <div className="mt-[-2rem]">
      <EcosystemFeatures />
    </div>
  );
};
